import React, { useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const testimonials = [
  {
    image: "",
    name: "Jithin Garvasis",
    location: "New York, USA",
    comment: "We recently booked our *Bali honeymoon package* through Holiday Basket Travel and Tourism, and it was nothing short of amazing! From the moment we landed in Bali, every detail was perfectly handled — making our entire trip stress-free and absolutely unforgettable. \n \n If you're planning a honeymoon or any personalized travel experience and want a perfect blend of luxury, culture, and natural beauty, we highly recommend Holiday Basket Travel and Tourism. They truly made our honeymoon a magical and memorable."
  },
  {
    image: "img/testimonial-2.jpg",
    name: "Anoop Mathew",
    location: "Lisbon, Portugal",
    comment: "Excellent Service from Holiday Basket!\nHoliday Basket is the best visa service I’ve experienced. Earlier, I used one of the most famous visa agencies in Kochi, Kerala, but they charged too much and asked for too many documents, which made things stressful and difficult.\n\n This time, I applied for my mother-in-law’s UK visit visa through Holiday Basket, and the experience is totally different. They are professional, don’t ask for unnecessary documents, charge less, and their customer service is excellent.\n\n I received the visa in just 5 working days. Thank you, Holiday Basket – you really made it simple and stress-free for us!"
  },
  {
    image: "img/testimonial-3.jpg",
    name: "Hrudya Manoj",
    location: "Delhi, India",
    comment: "I had a wonderful experience with this agency for my UK visiting visa. They made the whole process very easy and smooth. The staff were extremely helpful, professional, and friendly throughout. They guided me clearly at every step and responded quickly to all my questions. The service was fast, reliable, and affordable — much better than I expected.\n\nThanks to their support, I got my UK visa without any hassle. I truly appreciate their excellent service and would highly recommend this agency to anyone looking for visa assistance."
  },
  {
    image: "img/testimonial-4.jpg",
    name: "Dante Mathew",
    location: "Toronto, Canada",
    comment: "Great Experience with Holiday Basket!\nI applied for my mother’s UK visit visa through Holiday Basket and had an excellent experience. The process was smooth, they asked only for the required documents, and their service was professional and friendly.\n\nThe visa was approved in just 5 working days, and the charges were very reasonable. I’m really happy with their support and highly recommend Holiday Basket for UK visa services."
  }
];

const Testimonial = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: false,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <div className="container-fluid testimonial py-5">
      <div className="container py-5">
        <div className="mx-auto text-center mb-5" style={{ maxWidth: '900px' }}>
          <h5 className="section-title px-3">Testimonial</h5>
          <h1 className="mb-0">Our Clients Say!!!</h1>
        </div>
        <Slider {...settings}>
          {testimonials.map((item, index) => {
            const centerIndex = currentSlide + Math.floor(settings.slidesToShow / 3);
            const isActive = index === centerIndex;
            return (
              <div key={index}>
                <div className={`testimonial-item text-center bg-light testimonial-comment rounded pb-4 m-2 ${isActive ? 'center-sld' : ''}`}>
                  {/* <div className="  rounded p-4">
                    <p className="text-start mb-2">{item.comment}</p>
                  </div> */}
                  <div className="rounded p-4">
                    {/* 'whitespace-pre-line' class add ki hai neeche */}
                    <p className="text-start mb-2 whitespace-pre-line" style={{whiteSpace:"pre-line"}}>{item.comment}</p>
                  </div>
                  <div >
                    <h5 className="mb-0">{item.name}</h5>
                    {/* <p className="mb-0">{item.location}</p> */}
                    <div className="d-flex justify-content-center">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className="fas fa-star text-warning"></i>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonial;
